export const sceneGem = `
    vec3 sceneGem(vec3 rd, float time) {
        vec3 ro=vec3(0.,0.,5.); vec4 o=vec4(0.); float d=0.;
        float sw=sin(rd.x*2.+rd.y*2.-time*1.5); float gl=smoothstep(.95,1.,sw);
        for(float i=0.; i<32.; i++) {
            vec3 p=ro+rd*d; p.xz*=rot(time*.2); p.xy*=rot(time*.1);
            float s=length(p)-2.5; float c=sin(length(fract(p)*p));
            float h=max(c,s)-(i*.01); float sd=.012+.07*abs(h); d+=sd;
            o.rgb+=sin(vec3(1.,2.,3.)+i*.3)*((1.95+gl*5.)/sd);
            if(d>15.) break;
        }
        vec3 f=o.rgb*o.rgb/200000.; return f/(1.+f);
    }
`;
